import { api } from '../../../servicesGlobais/api'
import { ErroSistemaArquivo } from '../tipos/errosSistema'

export function listarErrosSistema(limitePorArquivo = 100): Promise<ErroSistemaArquivo[]> {
  const params = new URLSearchParams()
  if (limitePorArquivo > 0) params.append('limitePorArquivo', String(limitePorArquivo))
  const query = params.toString()
  const url = `/erros-sistema${query ? `?${query}` : ''}`
  return api.get<ErroSistemaArquivo[]>(url)
}

